import React, { FC } from 'react'
import cx from 'classnames'
import styles from './Card.module.scss'

type CardProps = {
  className?: string
}

export const Card: FC<CardProps> = ({ children, className }) => {
  return <div className={cx(styles.card, className)}>{children}</div>
}

Card.displayName = 'Card'
